/* eslint-disable consistent-return */
document.addEventListener('DOMContentLoaded', () => {
	const collapseButtonsCollection = document.querySelectorAll('.collapse-toggle')

	if (!collapseButtonsCollection) {
		return
	}

	function slidetoggle(el, h) {
		if (!el) {
			return
		}

		const ch = el.clientHeight
		const sh = el.scrollHeight
		const isCollapsed = !ch
		const noHeightSet = parseInt(el.style.maxHeight, 10) !== sh

		if (isCollapsed || noHeightSet) {
			el.style.maxHeight = `${sh}px`
		} else {
			el.style.maxHeight = `${h}px`
		}

		if (noHeightSet) {
			return slidetoggle.call(this)
		}
	}

	collapseButtonsCollection.forEach(collapseButton => {
		const collapseContent = collapseButton.nextElementSibling
		const collapseContentHeight = collapseContent.offsetHeight
		collapseContent.style.maxHeight = `${collapseContentHeight}px`
		collapseContent.style.transition = 'max-height 0.3s ease'

		collapseButton.addEventListener('click', () => {
			const icon = collapseButton.querySelector('svg')
			icon.style.rotate = icon.style.rotate === '90deg' ? '0deg' : '90deg'

			collapseContent.classList.toggle('line-clamp-1')

			slidetoggle(collapseContent, collapseContentHeight)
		})
	})
})
